import { Tab, Tabs } from "react-bootstrap";
// import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
// import { GetStatusIntegracaoUauController } from "../../../Controllers/Geral/Dashboard/DashboardController";
// import useAsyncEffect from "../../../hooks/useAsyncEffect";
import Negativar from "./Negativar";
import Positivar from "./Positivar";

export default function Serasa() {
    // const {
    //     value: getStatusIntegracaoUau,
    //     loading: getStatusIntegracaoUauLoading,
    // } = useAsyncEffect(() => GetStatusIntegracaoUauController());

    return (
        <>
            <div className="card card-custom">
                {/* {getStatusIntegracaoUauLoading ? (
                    <div className="text-center my-6">
                        <Spinner size="md" color="primary" />
                    </div>
                ) : getStatusIntegracaoUau?.FL_STATUS_ETL === false ? (
                    <div className="text-center ">
                        <h5 className="text-danger text-center my-6">
                            Serviço Indisponível - A carga de dados não foi
                            executada, entre em contato com o administrador do
                            sistema!
                        </h5>
                    </div>
                ) : ( */}
                <Tabs
                    defaultActiveKey="Negativar"
                    transition={false}
                    id="noanim-tab-example"
                    className="mb-3 ml-5 mt-2 d-flex"
                >
                    <Tab eventKey="Negativar" title="A Negativar">
                        <Negativar />
                    </Tab>
                    <Tab eventKey="Positivar" title="A Positivar">
                        {" "}
                        <Positivar />
                    </Tab>
                </Tabs>
                {/* )} */}
            </div>
        </>
    );
}
